import { useEffect, useMemo, useState } from 'react'
import './componentsCss/ListCardAgreements.css'
import api from '../api'
import Loading from './Loading'
import { Link } from 'react-router-dom'
import debounce from '../utils/debounce'

import './componentsCss/ListCardShoppers.css'

function ListCardProcedures({ search }) {
    const [data, setData] = useState([])

    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [finalPage, setFinalPage] = useState(null)
    const [debouncedSearch, setDebouncedSearch] = useState(search)

    const handleScroll = (event) => {
        if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 90 && !loading && !(page - 1 === finalPage)) {
            getData()
        }
    }

    const debouncedSetSearch = useMemo(() => {
      return debounce((value) => {
        setDebouncedSearch(value);
      }, 500);
  }, [setDebouncedSearch]);
    
  useEffect(() => {
      debouncedSetSearch(search);
  }, [search, debouncedSetSearch]);

    const getData = (exception = false, page2 = null) => {

        if (((page > finalPage && finalPage !== null) || loading) && exception === false) {
            // Já carregamos todas as páginas disponíveis ou esta carregando
            return;
        }

        setLoading(true)

        if (debouncedSearch !== "") {
            api.get('/api/procedures/search/' + debouncedSearch + '?page=' + String(page2 === null ? page : page2)).then((response) => {
                setData(page2 === null ? data.concat(response.data.data) : response.data.data)
                setFinalPage(response.data.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching shoppers:', error);
            }).finally(() => {
                setLoading(false)
            })
        } else {
            api.get('/api/procedures?page=' + String(page)).then((response) => {
                setData(data.concat(response.data.data))
                setFinalPage(response.data.meta.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching professionals:', error);
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        if (debouncedSearch === "") {
            setFinalPage(null)
            setPage(1)
            setData([])

            getData()

        } else {
            getData(true, 1)
        }
    }, [debouncedSearch])

    useEffect(() => {

        var el = document.getElementsByClassName('scroll-list-container')[0]

        if (el.scrollHeight <= window.innerHeight) {
            getData()
        }

    }, [page])


    return (
        <div onScroll={handleScroll} className='container-scroll'>
            <div className="row row-subcontainer scroll-list-container">
                {
                    data.length > 0 ? 
                    data.map((item, index) => {
                        return <Link to={"/procedures/" + item.id} className='col-12 col-sm-6 col-md-6 col-lg-4' style={{ padding: '0px 10px' }} key={item.id}>
                            <div className='card-list-shopper'>
                                <div className='col-12'>
                                    <span className=''>{item.name}</span>
                                    <span className='d-block small my-1'>Código: {item.cbhpm_code}</span>
                                    <span className='d-block small'>Setor: {item.sector}</span>
                                </div>
                            </div>
                        </Link>
                    }) : !loading ? <div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem Procedimentos</h6></div> : <></>

                }
                {loading ? <Loading /> : <></>}
            </div>
        </div>

    )
}

export default ListCardProcedures;